import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Button, Row, Col, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faInfo,
    faEdit,
    faTrash,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
//import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from 'sweetalert';
import { deleteReglaNegocio } from "./ReglaNegocioAction";
import { withRouter } from 'react-router-dom';


const { SearchBar } = Search;

const defaultSorted = [
    {
        dataField: "idreglanegocio",
        order: "asc",
    },
];

const mapStateToProps = (state) => {
    //console.log("Javier -------> Se carga TableComponent|MapStateToProps ");

    return {
        getReglaNegocioList: state.ReglaNegocioReducer.getReglaNegocioList,
        errorReglaNegocioList: state.ReglaNegocioReducer.errorReglaNegocioList,
        getReglaNegocioBorrar: state.ReglaNegocioReducer.getReglaNegocioBorrar,
        errorReglaNegocioBorrar: state.ReglaNegocioReducer.errorReglaNegocioBorrar,
    };

};

function columnFormatter(cell, row) { return (<span className="font-12">{cell}</span>); }

function headFormatter(column, colIndex) { return (<strong >{column.text}</strong>); }


const ReglaNegocioTabla = (props) => {
    //console.log("Javier -------> Se carga TableComponent | PROPS");


    const columns = [
        {
            dataField: "idreglanegocio",
            text: "ID",
            sort: true,
            headerStyle: () => {
                return { width: "5%", color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nombre",
            text: "Nombre",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "tipo",
            text: "Tipo",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "valor",
            text: "Valor",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "operacion",
            text: "Operación",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "asignar",
            text: "Proceso",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },        
        {
            dataField: "link",
            text: "",
            formatter: (rowContent, row) => {
                return (
                    <div>
                        <Link to={"detallereglanegocio/" + row.idreglanegocio}>
                            <button type="button" className="btn btn-icon btn-sm" title="View"><i className="fa fa-eye"></i></button>
                        </Link>

                        <Link to={"editarreglanegocio/" + row.idreglanegocio}>
                            <button type="button" className="btn btn-icon btn-sm" title="Edit"><i className="fa fa-edit"></i></button>
                        </Link>

                        <Link to={"borrarreglanegocio/" + row.idreglanegocio}>
                            <button type="button" className="btn btn-icon btn-sm" title="Edit"><i className="fa fa-trash-o text-danger"></i></button>
                        </Link>

                    </div>
                );
            },
        },
    ];


    var total = props.getReglaNegocioList.length;

    return (

        <Container>

            {
                props.getReglaNegocioList ? (
                    <ToolkitProvider
                        bootstrap4
                        keyField="idreglanegocio"
                        data={props.getReglaNegocioList}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                    >
                        {(props) => (
                            <div>
                                <Row>
                                    <Col>
                                        <div className="float-right">
                                            <SearchBar {...props.searchProps} placeholder="Buscar En Lista .." />
                                        </div>
                                    </Col>
                                </Row>

                                <BootstrapTable
                                    className="table table-sm table-hover table-striped table-vcenter mb-0 text-nowrap"
                                    keyField="idreglanegocio"
                                    {...props.baseProps}
                                    pagination={paginationFactory(
                                        {
                                            showTotal: true, // display pagination information
                                            sizePerPageList: [
                                                {
                                                    text: '50', value: 50
                                                },
                                                {
                                                    text: '100', value: 100
                                                },
                                                {
                                                    text: 'Todos', value: total
                                                }
                                            ],
                                            firstPageText: 'Primero', // the text of first page button
                                            prePageText: 'Previo', // the text of previous page button
                                            nextPageText: 'Siguiente', // the text of next page button
                                            lastPageText: 'Ultimo', // the text of last page button
                                            nextPageTitle: 'Ir Siguiente', // the title of next page button
                                            prePageTitle: 'Ir Previo', // the title of previous page button
                                            firstPageTitle: 'Ir Primero', // the title of first page button
                                            lastPageTitle: 'Ir Ultimo', // the title of last page button
                                        }
                                    )
                                    }
                                />
                            </div>
                        )}
                    </ToolkitProvider>
                ) :
                (
                    <div className="text-center">
                        {props.errorReglaNegocioList ? (
                            <h4>{props.errorReglaNegocioList}</h4>
                        ) : (
                                <Spinner color="dark" />
                            )}
                    </div>
                )
           }
        </Container>

    );
};

export default withRouter(connect(mapStateToProps, null)(ReglaNegocioTabla));

